import { MonthLeft, MonthRight } from "../PickerHeader";

export default function MobilePickerTopHeader(props) {
    let { month1, setViewDate, isFixed, disabled } = props;
    
    return (
        <div className="picker-header">
            <span className="top-calendar-label">
                <b className="flex-container all-center">
                    {!isFixed && <MonthLeft setViewDate={setViewDate} viewDate={month1} className={"set-width"} disabled={disabled} />}
                    <div className="set-width text-center"><span className='month'>{month1.getLongMonth}</span> <span className='year'>{month1.yearInt}</span></div>
                    {!isFixed && <MonthRight setViewDate={setViewDate} viewDate={month1} disabled={ disabled } className="set-width" />}
                </b>
            </span>
        </div>
    )
}